import baseScmService from 'services/baseScmService';

const sbatGroupAcademyTopicService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateSbatGroupAcademyTopic: build.mutation({
      query: ({ sbatGroupId, academyTopic }) => ({
        method: 'PUT',
        url: `/sbat-groups/${sbatGroupId}/academy-topics/`,
        body: {
          academy_topic: {
            title: academyTopic.title,
            junction_number: academyTopic.junction_number,
            academy_module_id: academyTopic.academy_module?.id,
            bucket_id: academyTopic.lecture_bucket?.id || null,
          },
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateSbatGroupAcademyTopicMutation } =
  sbatGroupAcademyTopicService;

export default sbatGroupAcademyTopicService;
